import chanelTheme from 'components/chanel/shared/themeStyling';
import type { ThemeType } from 'components/shared/productList/shared/types';
import usePageContext from 'hooks/user/usePageContext';
import defaultTheme from './defaultTheme';
import regimeTheme from './miscellaneous/regimeTheme';
import secondaryTheme from './miscellaneous/secondaryTheme';

export default function useThemeHandler(themeType?: ThemeType) {
    const pageContext = usePageContext();
    const brandContext = pageContext?.brandContext;
    const theme = (brandContext as ThemeType) || themeType;

    switch (theme) {
        case 'chanel':
            return chanelTheme;
        case 'regime':
            return regimeTheme;
        case 'secondary':
            return secondaryTheme;
        default:
            return defaultTheme;
    }
}
